import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Check, Ticket } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const FeaturedCodeBanner = () => {
  const [code, setCode] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/discount-codes/featured").then(({ data }) => setCode(data?.code ? data : null)).catch(() => {}); }, []);
  if (!code) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(code.code); setCopied(true); toast.success(`Codice ${code.code} copiato`); setTimeout(() => setCopied(false), 2500); } catch { /* clipboard non disponibile */ }
  };
  const label = code.type === "percentage" ? `-${Number(code.value)}%` : `-€${Number(code.value).toFixed(2)}`;
  return (
    <section className="bg-[#D4AF37] text-black" data-testid="featured-code-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex items-center gap-3">
          <Ticket className="w-8 h-8 shrink-0" />
          <div>
            <div className="font-display font-black text-xl sm:text-2xl leading-none">{label} SU TUTTO IL CATALOGO ONLINE</div>
            <div className="text-xs mt-1 text-black/70">Inserisci il codice nel carrello · solo acquisti online · non cumulabile con tessera Silver/Gold</div>
          </div>
        </div>
        <div className="flex items-center gap-2 md:ml-auto">
          <button onClick={copy} className="flex items-center gap-2 border-2 border-dashed border-black px-4 h-11 font-display font-black text-xl tracking-[0.2em] hover:bg-black hover:text-[#D4AF37] transition-colors" data-testid="featured-code-copy">
            {code.code} {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </button>
          <Link to="/catalog" className="bg-black text-white px-5 h-11 leading-[44px] font-overline text-[10px] hover:bg-neutral-800 transition-colors" data-testid="featured-code-shop">ACQUISTA ORA</Link>
        </div>
      </div>
    </section>
  );
};
